/* eslint-disable multiline-ternary */
import {
  Button,
  Collapse,
  Grid,
  IconButton,
  Paper,
  SvgIconTypeMap
} from '@material-ui/core'
import { OverridableComponent } from '@material-ui/core/OverridableComponent'
import Delete from '@material-ui/icons/Delete'
import Edit from '@material-ui/icons/Edit'
import React from 'react'
import { useHistory } from 'react-router'
import { ReactComponent as ProcedureIcon } from '../../Assets/procedure.svg'
import BudgetCard from '../../Budget/BudgetCard'
import { useBudgetStyles } from '../../Budget/styles'
import { Procedure } from '../../Budget/types'

type ProcedureProps = {
  procedure: Procedure
  handleSelect?: (procedure: Procedure) => void
  icon?: OverridableComponent<SvgIconTypeMap<unknown, 'svg'>>
  style?: React.CSSProperties
  handleDelete?: () => void
}

const ProcedureCard: React.FC<ProcedureProps> = ({
  procedure,
  handleSelect,
  icon: Icon,
  style,
  handleDelete
}) => {
  const [expanded, setExpanded] = React.useState<boolean>(false)

  const handleExpandClick = () => {
    setExpanded(!expanded)
  }

  const classes = useBudgetStyles()
  const history = useHistory()

  const handleEditProcedure = () => {
    history.push(`/configuracao/procedimentos/${procedure.id}`)
  }

  return (
    <div
      style={{
        background: 'white',
        borderRadius: 8,
        border: '1px solid #333'
      }}
    >
      <Paper
        style={{ ...style, marginBottom: 0 }}
        elevation={0}
        className={classes.root}
        onClick={() => handleExpandClick()}
      >
        <Grid container justify="space-around" alignItems="center">
          <Grid xs={4} className={classes.name} style={{ textAlign: 'left' }}>
            <ProcedureIcon
              className={classes.icon}
              style={{ marginRight: 10 }}
            />
            {procedure.name}
          </Grid>
          <Grid
            xs={3}
            className={classes.value}
            style={{ textAlign: 'center' }}
          >
            {procedure.totalPrice.format}
          </Grid>
          <Grid xs={3} style={{ textAlign: 'right' }}>
            {Icon && <Icon />}
          </Grid>
          <Grid xs={1}>
            <IconButton onClick={handleEditProcedure}>
              <Edit />
            </IconButton>
          </Grid>
          {handleDelete && (
            <Grid xs={1}>
              <IconButton onClick={handleEditProcedure}>
                <Delete />
              </IconButton>
            </Grid>
          )}
        </Grid>
      </Paper>
      <Collapse in={expanded} unmountOnExit>
        <br />
        {procedure.items.map((item, i) => (
          <BudgetCard procedureItem={item} key={`procedure-item-${i}`} />
        ))}
        {handleSelect && (
          <Button
            color="primary"
            onClick={() => handleSelect(procedure)}
            variant="contained"
            style={{ margin: '0 0 20px 20px' }}
          >
            Selecionar
          </Button>
        )}
      </Collapse>
    </div>
  )
}

export default ProcedureCard
